export function LanguageTabs({
  active,
  onChange,
  className = "",
}: {
  active: "es" | "en";
  onChange: (language: "es" | "en") => void;
  className?: string;
}) {
  const options: Array<{ code: "es" | "en"; label: string }> = [
    { code: "es", label: "ES" },
    { code: "en", label: "EN" },
  ];

  return (
    <div className={`inline-flex rounded-full bg-app-control p-1 shadow-inner ${className}`} role="tablist" aria-label="Language">
      {options.map(option => {
        const isActive = active === option.code;
        return (
          <button
            key={option.code}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`px-4 py-1.5 text-sm font-semibold rounded-full transition-all duration-200 cursor-pointer ${
              isActive ? "bg-brand text-white shadow" : "text-app-muted hover:text-brand hover:bg-app-control-hover"
            }`}
            onClick={() => onChange(option.code)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
